import * as React from "react";
import PropTypes from 'prop-types';

const SvgShoppingBagFill = props => {
  if (props.id !== "_svgshoppingbagfill") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><path d="M7.964 11.907H4.589c-.117 0-.426.081-.597.244-.308.295-1.874 2.037-2.13 2.363-.255.326-.255.651-.255.651L0 34.696c.003.66.683 1.296 1.363 1.304h23.274c.68 0 1.358-.66 1.363-1.304l-1.607-19.53s0-.326-.34-.652c-.294-.28-1.757-2.08-2.045-2.363a.785.785 0 00-.597-.244h-3.464v10.518c-.043.448-.368.673-.976.673s-.922-.225-.941-.673l-.11-10.518H9.807v10.486c-.027.47-.342.705-.946.705-.604 0-.902-.235-.896-.705V11.907zm0-.02h1.842V6.266c-.064-3.16 1.005-4.747 3.207-4.758C15 1.52 15.95 3.107 15.862 6.266v5.653h2.085V5.347C17.779 1.782 16.115 0 12.956 0c-3.16 0-4.824 1.785-4.992 5.356v6.53z" /></svg>;
};

SvgShoppingBagFill.displayName = "_svgshoppingbagfill";
SvgShoppingBagFill.propTypes = {
  id: PropTypes.string
};
SvgShoppingBagFill.defaultProps = {
  id: ''
};
export default SvgShoppingBagFill;